import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "src/lib/utils";

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>
>(({ className, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    className={cn(
      "group relative flex w-full touch-none select-none items-center my-0.5",
      className,
    )}
    {...props}
  >
    <SliderPrimitive.Track className="group-hover:shadow-inset relative h-12 w-full grow overflow-hidden rounded-full hover:shadow-inset focus-visible:shadow-inset bg-input" />
    <SliderPrimitive.Thumb className="cursor-pointer block h-[calc(3rem+2px)] shadow-thumb w-[calc(3rem+2px)] rounded-full bg-background transition-colors focus-visible:outline-none focus:bg-lightgray disabled:pointer-events-none disabled:opacity-50" />
  </SliderPrimitive.Root>
));
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
